import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar  from './Component/NavBar/nav.tsx';
import Home from './Component/Home/home.tsx' 
import About from './Component/About/about.tsx';
import Technology from './Component/Techs/technologys.tsx'
import Footer from './Component/Footer/footer.tsx';
import Contact from './Component/Contact/contact.tsx';
const App = () => {
  return (
    <div className="App">
    
     <Navbar/>
     <Home  />
      <About  />
      <Technology  />
      <Contact />
     <Footer/>
    </div>
  );
};

export default App;
